import { get } from 'lodash-es';
import createCachedSelector from 're-reselect';

import { emptyArray, emptyObject } from 'ui-components/default-props/empty';

const selectJobIdToFulfillmentSetIdMap = (state) => get(state, 'jobIdsToFpSetIdMap', emptyObject);
export const selectFufillmentPlanSetIdByJobId = (state, props) => get(selectJobIdToFulfillmentSetIdMap(state), props.jobId);
export const selectFulfillmentPlanSetIdDerivedData = (state, props) => get(state, props.fulfillmentPlanSetId, emptyObject);
export const selectShipDate = (state) => get(state, 'shipDate');
export const selectLabelBatchStatusModalId = (state) => get(state, 'lbsModalId', '');
export const selectBatchIdsByParentBatchId = createCachedSelector(
  selectJobIdToFulfillmentSetIdMap,
  (_, props) => props.batchId,
  (allBatchIds, batchId) => {
    const batchIdsFiltered = Object.entries(allBatchIds).filter((entry) => entry[1] === batchId);
    if (batchIdsFiltered.length === 0) {
      return emptyArray;
    }
    return batchIdsFiltered.map((entry) => entry[0]);
  },
)((_, props) => props.batchId);
